import Typography from '@/components/typography';
import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { type ComponentProps } from 'react';

const headingStyles = cva('', {
  variants: {
    variant: {
      title: 'text-7xl font-semibold', //72px
      subTitle: 'text-2xl', //24px
      heading2: 'text-4xl font-medium', //36px
      heading3: 'text-xl font-semibold', //20px
      tableHeading: 'text-sm font-semibold', //14px
    },
  },
});

type TypographyProps = ComponentProps<typeof Typography>;
type Props = VariantProps<typeof headingStyles> & Omit<TypographyProps, 'classNames'> & { className?: string };

export const Heading = ({ element, children, color, variant, className }: Props) => {
  return (
    <Typography element={element} color={color} classNames={cn(headingStyles({ variant }), className)}>
      {children}
    </Typography>
  );
};
